/**
 * Creates an entity response object that can be picked up automatically by the entities reducer
 *
 * @param  {string} type - entity type, which is used as the key in state.entities
 * @param  {string} id - unique identifier for the entity (eg. store.entities[type][id])
 * @param  {Object} [patch] - data to store on the entity in addition to the id
 * @return {Object} response object containing entities and the result
 */
export const createEntityResponse = (type, id, patch) => ({
    entities: {
        [type]: {
            [id]: { id, ...patch },
        },
    },
    result: {
        [type]: [id],
    },
});

export const getIdFromEntityResponseResults = (results, schema) => {
    let schemaId = results[`${schema}s`] || results[schema];
    Array.isArray(schemaId) || (schemaId = [schemaId]);
    return schemaId;
};

/**
 * Patches each object in an array or dictionary by assigning to each value
 *
 * This is useful when dealing with entities in a Redux store when you want to set some values on
 * every entity
 *
 * @param  {Object|Array} obj - collection of objects to patch
 * @param  {Object|function} patch - object to assign to the existing entity, or a function that
 *         returns such an object
 * @return {Object} original object
 */
export const patchObjectValues = (obj, patch) => {
    Object.keys(obj).forEach((key) => {
        Object.assign(obj[key], typeof patch === 'function' ? patch(obj[key]) : patch);
    });
    return obj;
};

/**
 * Creates a simple reducer that sets state to either true or false
 * depending on the action given.
 *
 * @param {string|array} truthyActionTypes
 * @param {string|array} falsyActionTypes
 * @param {*} defaultValue
 */
export const createBooleanReducer =
    (truthyActionTypes, falsyActionTypes, defaultValue = false) =>
    (state = defaultValue, action) => {
        if (
            action.type === truthyActionTypes ||
            (Array.isArray(truthyActionTypes) && truthyActionTypes.includes(action.type))
        ) {
            return true;
        } else if (
            action.type === falsyActionTypes ||
            (Array.isArray(falsyActionTypes) && falsyActionTypes.includes(action.type))
        ) {
            return false;
        } else {
            return state;
        }
    };
